import React, { useEffect } from 'react'
import RulesSettings from '../components/Settings/RulesSettings'
import { useAppLayoutResetter } from '@caudena/core/state'

export const PageRulesSettings = () => {
  const resetLayout = useAppLayoutResetter()
  useEffect(() => {
    resetLayout()
  }, [])
  return <RulesSettings />
}

export default PageRulesSettings
